import * as actionTypes from "./actionTypes";

const nonSaleableReturnReducer = (state = [], payload) => {
  switch (payload.type) {
    case actionTypes.ADD_NEW_NON_SALEABLE_RETURN_SUCCESS:
      return [...payload.nonSaleableReturnData];

    case actionTypes.EDIT_NON_SALEABLE_RETURN_SUCCESS:
      return [...payload.nonSaleableReturnData];

    case actionTypes.DELETE_NON_SALEABLE_RETURN_SUCCESS:
      return [...payload.nonSaleableReturnData];

    default:
      return state;
  }
};

export default nonSaleableReturnReducer;
